import React from 'react';

const AddEquipmentModal = ({
  show,
  onClose,
  equipmentForm,
  onEquipmentFormChange,
  onSubmit,
  availableEquipment,
  isLoading,
  groupName,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="w-full max-w-md rounded-lg bg-white">
        <div className="p-6">
          <h3 className="mb-4 text-lg font-medium text-gray-900">Add Equipment to {groupName}</h3>

          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">
                Select Equipment
              </label>
              <select
                name="equipment_id"
                value={equipmentForm.equipment_id}
                onChange={onEquipmentFormChange}
                className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              >
                <option value="">Select equipment</option>
                {availableEquipment.map((eq) => (
                  <option key={eq.id} value={eq.id}>
                    {eq.name} ({eq.equipment_type})
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">
                Priority (1 = highest)
              </label>
              <input
                type="number"
                name="priority"
                min="1"
                max="10"
                value={equipmentForm.priority}
                onChange={onEquipmentFormChange}
                className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">Notes</label>
              <textarea
                name="notes"
                value={equipmentForm.notes}
                onChange={onEquipmentFormChange}
                className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows={2}
                placeholder="Optional notes about this equipment assignment"
              />
            </div>

            <div className="flex gap-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 rounded bg-gray-200 px-4 py-2 font-semibold text-gray-900 transition-colors hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="flex-1 rounded bg-blue-500 px-4 py-2 font-semibold text-white transition-colors hover:bg-blue-600 disabled:bg-blue-300"
                disabled={isLoading || !equipmentForm.equipment_id}
              >
                {isLoading ? 'Adding...' : 'Add Equipment'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddEquipmentModal;
